import axios from "axios";
import URL from "./url";
import API_URL from "./url";
import { useNavigate } from "react-router-dom";
import { notification } from "antd";

const api = axios.create({
  baseURL: API_URL.BASEURL,
  withCredentials: true, 
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accesstoken");
    console.log("token", token)
    if (token) {
      config.headers.accessToken = `${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    //  console.log(response);

    // if (response?.config?.config?.showMessage || response?.config?.params?.showMessage) {
    //   notification.success({
    //     message: "Success",
    //     description: response.data.message || "Request completed successfully!",
    //   });
    // }
    return response;
  },
  (error) => {
    console.log(error);

    notification.error({
      message: error.response?.data?.message || error.message,
    });
    if (error?.response?.status === 401) {
      // navigate('/login');
      // console.log("token delete");
      //window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export default api;